import React from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import App from 'views/App';
import createStore from 'store';

/* eslint-disable */
const preloadedState = window.__PRELOADED_STATE__;
delete window.__PRELOADED_STATE__;
/* eslint-enable */

const customMiddleware = [];
if (process.env.NODE_ENV === `development`) {
  const logger = require(`redux-logger`).createLogger({ // eslint-disable-line
    collapsed: true,
  });

  customMiddleware.push(logger);
}

const store = createStore(preloadedState, customMiddleware);
const basename = process.env.API_ENV === `staging`
  ? `/staging/starlies/`
  : `/`;

ReactDOM.hydrate(
  <Provider store={store}>
    <Router basename={ basename } >
      <App />
    </Router>
  </Provider>,
  document.getElementById(`root`),
);
